import { Injectable, signal, computed } from '@angular/core';
import { AdminCommonHttpService } from '../components/admin/service/admin-common-http.service';


export interface VariantKey {
  key_code: string;
  display_name: string;
}

export interface Variant {
  variant_id: number;
  variant_key: string;
  price: number;
  attributes: Record<string, string>;
}

@Injectable({ providedIn: 'root' })
export class VariantStore {

  // SIGNALS (State)
  private variantKeysSignal = signal<VariantKey[]>([]);
  private variantsSignal = signal<Variant[]>([]);
  private loadingSignal = signal(false);

  // COMPUTED (readonly reactive state)
  readonly variantKeys = computed(() => this.variantKeysSignal());
  readonly variants = computed(() => this.variantsSignal());
  readonly loading = computed(() => this.loadingSignal());

  constructor(private api: AdminCommonHttpService) { }

  // LOAD ALL KEYS
  async loadVariantKeys() {
    this.loadingSignal.set(true);
    const data = await this.api.getVariantKeys();
    this.variantKeysSignal.set(data ?? []);
    this.loadingSignal.set(false);
  }

  // CREATE NEW VARIANT KEY
  async createVariantKey(key_code: string, display_name: string) {
    const newKey = await this.api.createVariantKey(key_code, display_name);

    this.variantKeysSignal.update(keys => [...keys, newKey]);
    return newKey;
  }

  // DELETE VARIANT KEY
  async deleteVariantKey(key_code: string) {
    await this.api.deleteVariantKey(key_code);

    this.variantKeysSignal.update(keys =>
      keys.filter(k => k.key_code !== key_code)
    );
  }

  // CREATE VARIANT
  async createVariant(productId: number, variant: any) {
    const payload = { product_id: productId, ...variant }
    const newVar = await this.api.createProductVariant(payload);
    this.variantsSignal.update(list => [...list, newVar]);
  }
}
